(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var close = document.querySelector('[data-bk-announce-close]');
  if (!close) return;
  close.addEventListener('click', function(){
    var bar = close.closest('.bk-announce');
    if (bar) bar.style.display = 'none';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-bk-faq]').forEach(function(faq){
    var items = [].slice.call(faq.querySelectorAll('.bk-faq__item'));
    items.forEach(function(item){
      var trigger = item.querySelector('.bk-faq__trigger');
      trigger.addEventListener('click', function(){
        var open = item.classList.contains('is-open');
        items.forEach(function(o){
          o.classList.remove('is-open');
          o.querySelector('.bk-faq__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-featured-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-bk-featured-form]').forEach(function(form){
    var plans = form.querySelectorAll('.bk-featured__plan');
    var spInput = form.querySelector('[data-bk-selling-plan-input]');
    var ctaLabel = form.querySelector('[data-bk-cta-label]');
    var priceData = form.querySelector('[data-bk-prices]');
    var prices = null;
    if (priceData) {
      try { prices = JSON.parse(priceData.textContent); } catch(e) {}
    }

    function format(amount){
      // amount is in cents; Shopify's money filter is locale-aware server-side.
      // For dynamic updates, we use a simple GBP format. Brands with non-GBP
      // storefronts will need to swap this for window.Shopify.formatMoney.
      return '£' + (amount/100).toFixed(2);
    }

    plans.forEach(function(btn){
      btn.addEventListener('click', function(){
        plans.forEach(function(b){ b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var plan = btn.dataset.plan;
        if (spInput) {
          if (plan === 'sub' && prices && prices.sub) {
            spInput.value = prices.sub.id;
            spInput.disabled = false;
          } else {
            spInput.disabled = true;
          }
        }
        if (ctaLabel && prices && prices[plan]) {
          ctaLabel.textContent = 'Add to cart · ' + format(prices[plan].amount);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-header"]) return;
  try {
    
(function(){

  /* ===== MOBILE DRAWER ===== */
  var drawer   = document.querySelector('[data-bk-menu-drawer]');
  var toggle   = document.querySelector('[data-bk-menu-toggle]');
  if (drawer && toggle) {
    function openDrawer(){
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(){
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-bk-menu-close]').forEach(function(el){
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ===== MOBILE ACCORDION ===== */
  document.querySelectorAll('[data-bk-accordion-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item  = btn.closest('.bk-header__drawer-item');
      var panel = item ? item.querySelector('[data-bk-accordion-panel]') : null;
      if (!panel) return;
      var isOpen = panel.classList.contains('is-open');
      panel.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      btn.classList.toggle('is-open', !isOpen);
    });
  });

  /* ===== STICKY HIDE-ON-SCROLL-DOWN ===== */
  var header = document.querySelector('[data-bk-header]');
  if (header && header.dataset.sticky !== 'false') {
    var lastY = 0;
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      if (y > 80 && y > lastY) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }

  /* ===== MEGA MENU ===== */
  var overlay   = document.querySelector('[data-bk-mega-overlay]');
  var megaItems = document.querySelectorAll('.has-mega');
  var openItem  = null;
  var closeTimer = null;

  function openMega(item) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (openItem && openItem !== item) closeMega(openItem, true);
    var id    = item.dataset.megaId;
    var panel = document.getElementById('mega-' + id);
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    item.querySelector('[aria-haspopup]').setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-visible');
    openItem = item;
  }

  function closeMega(item, immediate) {
    var id    = item ? item.dataset.megaId : null;
    var panel = id ? document.getElementById('mega-' + id) : null;
    function doClose(){
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
      if (item) {
        var link = item.querySelector('[aria-haspopup]');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
      if (overlay) overlay.classList.remove('is-visible');
      openItem = null;
    }
    if (immediate) { doClose(); } else { closeTimer = setTimeout(doClose, 120); }
  }

  megaItems.forEach(function(item){
    item.addEventListener('mouseenter', function(){ openMega(item); });
    item.addEventListener('mouseleave', function(){
      closeTimer = setTimeout(function(){
        if (openItem === item) closeMega(item, true);
      }, 120);
    });
  });

  /* Keep panel open when hovering the mega panel itself */
  document.querySelectorAll('.bk-header__mega').forEach(function(panel){
    panel.addEventListener('mouseenter', function(){
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    panel.addEventListener('mouseleave', function(){
      if (openItem) closeMega(openItem, false);
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function(){ if (openItem) closeMega(openItem, true); });
  }

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && openItem) closeMega(openItem, true);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Numbered accordion */
  document.querySelectorAll('[data-bk-acc]').forEach(function(acc){
    var items = [].slice.call(acc.querySelectorAll('.bk-pdp__acc-item'));
    items.forEach(function(it){
      var btn = it.querySelector('.bk-pdp__acc-trigger');
      if (!btn) return;
      btn.addEventListener('click', function(){
        var open = it.classList.contains('is-open');
        items.forEach(function(o){
          o.classList.remove('is-open');
          var t = o.querySelector('.bk-pdp__acc-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          it.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  /* Plan cards + quantity → keep the Add-to-cart price in sync (unit price × qty)
     for one-time, plan-toggle and Skio subscription products alike. */
  document.querySelectorAll('[data-bk-plan-cards]').forEach(function(wrap){
    var plans        = [].slice.call(wrap.querySelectorAll('.bk-pdp__plan'));
    var spInput      = wrap.querySelector('[data-bk-selling-plan-input]');
    var bigPrice     = wrap.querySelector('[data-bk-big-price]');
    var priceEl      = wrap.querySelector('[data-bk-skio-price]');
    var skioUnit     = wrap.querySelector('[data-bk-skio-unit]');
    var priceData    = wrap.querySelector('[data-bk-pdp-prices]');
    var variantInput = wrap.querySelector('[data-bk-variant-input]');
    var qtyInput     = wrap.querySelector('input[name="quantity"]');
    var prices = null;
    if (priceData) { try { prices = JSON.parse(priceData.textContent); } catch(e){} }

    var unitCents = parseInt(wrap.getAttribute('data-bk-unit-cents'), 10) || 0;

    function fmt(amount){
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(amount)
        : '£' + (amount / 100).toFixed(2);
    }
    function qty(){
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return (q && q > 0) ? q : 1;
    }
    function parseCents(str){
      if (!str) return 0;
      var n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : Math.round(n * 100);
    }
    function renderPrice(){
      if (!unitCents) return;
      var total = fmt(unitCents * qty());
      if (priceEl) priceEl.textContent = total;
      if (bigPrice) bigPrice.textContent = total;
    }

    plans.forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        plans.forEach(function(b){ b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');

        /* Variant-card mode: update hidden id input */
        var variantId = btn.dataset.variantId, variantPrice = btn.dataset.variantPrice;
        if (variantId && variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (variantPrice) { unitCents = parseInt(variantPrice, 10) || unitCents; }
          renderPrice();
          return;
        }

        /* Selling-plan toggle mode */
        var plan = btn.dataset.plan;
        if (spInput) {
          if (plan === 'sub' && prices && prices.sub) { spInput.value = prices.sub.id; spInput.disabled = false; }
          else { spInput.disabled = true; spInput.value = ''; }
          spInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (prices && prices[plan]) { unitCents = prices[plan].amount; }
        renderPrice();
      });
    });

    /* Skio writes the per-unit price into the hidden [data-bk-skio-unit];
       mirror it (× quantity) into the visible button price. */
    if (skioUnit) {
      new MutationObserver(function(){
        var c = parseCents(skioUnit.textContent);
        if (c) { unitCents = c; renderPrice(); }
      }).observe(skioUnit, { childList: true, subtree: true, characterData: true });
    }

    /* Quantity changes — Dawn's <quantity-input> fires 'change' on +/-. */
    if (qtyInput) {
      qtyInput.addEventListener('change', renderPrice);
      qtyInput.addEventListener('input', renderPrice);
    }

    renderPrice();
  });

  /* Mobile sticky ATC bar: reveal only after the inline Add-to-cart has scrolled
     up out of the viewport. Mirrors the real button's label/price/disabled state
     and delegates clicks to it, so all cart logic (variant, plan, AJAX) is reused. */
  (function(){
    var bar = document.querySelector('[data-bk-sticky-bar]');
    if (!bar) return;
    var realBtn = document.querySelector('[data-bk-plan-cards] .bk-pdp__atc');
    if (!realBtn) return;
    var stickyBtn = bar.querySelector('[data-bk-sticky-atc]');
    var stickyLabel = bar.querySelector('[data-bk-sticky-label]');
    var realLabel = realBtn.querySelector('[data-bk-cta-label]');

    function sync(){
      if (realLabel && stickyLabel) stickyLabel.innerHTML = realLabel.innerHTML;
      stickyBtn.disabled = realBtn.disabled;
    }
    sync();
    if (realLabel) new MutationObserver(sync).observe(realLabel, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });

    stickyBtn.addEventListener('click', function(){ realBtn.click(); });

    /* Reveal the bar once the inline ATC has scrolled fully above the viewport top.
       A passive scroll listener is used (not IntersectionObserver) because IO only
       fires on intersection state CHANGES — scrolling fast from below-the-fold to
       above-the-fold stays "not intersecting" the whole time and never fires. */
    var lastPassed = null;
    function update(){
      var passed = realBtn.getBoundingClientRect().bottom <= 0;
      if (passed === lastPassed) return;
      lastPassed = passed;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
